<template>
  <el-container direction="vertical">
    <ClientHeader />
    <el-container class="admin-container">
      <ClientSidebar :title="userInfo.master_brand_name" />
      <el-container direction="vertical">
        <el-main>
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </el-main>
        <ClientFooter />
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import ClientHeader from '@/components/layouts/client/Header'
import ClientSidebar from '@/components/layouts/client/Sidebar'
import ClientFooter from '@/components/layouts/client/Footer'
export default {
  name: 'ClientLayout',
  components: {
    ClientHeader,
    ClientSidebar,
    ClientFooter
  },
  computed: {
    userInfo: function () {
      return this.$store.getters.userInfo
    }
  }
}
</script>
